import { render, staticRenderFns } from "./DirectImageUpload.vue?vue&type=template&id=267e57ec"
import script from "./DirectImageUpload.vue?vue&type=script&lang=js"
export * from "./DirectImageUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports